import React, { useEffect, useState } from "react";
import TopNavigator from "../components/TopNavigator";
import { apiUrl } from "../config/api";

function PriceChangesPage() {
  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const response = await fetch(apiUrl("/api/last-prices"));
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "خطا در دریافت تغییرات قیمت");
        }

        setPrices(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err.message || "خطا در دریافت تغییرات قیمت");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const formatAmount = (value) =>
    Number(value || 0).toLocaleString("fa-IR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

  return (
    <div className="MainPageShell">
      <TopNavigator />
      <main className="container UserPortalPage">
        <section className="UserPortalHero">
          <span className="MainPageEyebrow">پرتال کاربر</span>
          <h2 className="MainPageTitle">تغییرات قیمت امروز</h2>
          <p className="MainPageDescription">
            آخرین قیمت‌های ثبت‌شده از بک‌اند در این بخش نمایش داده می‌شود.
          </p>
        </section>

        <section className="UserPortalPanel">
          {loading ? (
            <p className="UserPortalEmpty">در حال دریافت داده‌ها...</p>
          ) : error ? (
            <p className="UserPortalEmpty UserPortalError">{error}</p>
          ) : prices.length === 0 ? (
            <p className="UserPortalEmpty">داده‌ای برای نمایش وجود ندارد.</p>
          ) : (
            <div className="UserPortalTableWrap">
              <table className="UserPortalTable">
                <thead>
                  <tr>
                    <th>آیتم</th>
                    <th>قیمت خرید</th>
                    <th>قیمت فروش</th>
                    <th>زمان ثبت</th>
                  </tr>
                </thead>
                <tbody>
                  {prices.map((item) => (
                    <tr key={item.id}>
                      <td>{item.itemName}</td>
                      <td>{formatAmount(item.buyPrice)} ریال</td>
                      <td>{formatAmount(item.sellPrice)} ریال</td>
                      <td>{item.timestamp ? new Date(item.timestamp).toLocaleString("fa-IR") : "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

export default PriceChangesPage;
